import { Button, FileInput, Modal } from "@mantine/core"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  useLazyCountBillingsQuery,
  useLazyGetBillingQuery,
  usePayForOwnerBillManuallyMutation,
} from "../../../feature/billing/store/billing.query"
import { formatCurrency } from "../../../feature/dashboard/component/ReportCard"
import { RootState } from "../../../store/app.store"
import { notification } from "../../component/notification/utility/notification"
import { useCurrentUser } from "../../hooks/current-user.hook"
import { isUserActive } from "../../utility/isUserActive"
import { PaymentStatus } from "../../../models/payment.model"
import { OwnerStatus } from "../../../models/owner.model"
interface Props {
  children: any
  role?: string[]

  permission?: string[]
}
function AuthGuard(props: Props) {
  const { children, role, permission } = props
  const navigate = useNavigate()
  const [fileInput, setFileInput] = useState<File | null>(null)

  const [userInfo, _, ownerInfo, tenantInfo] = useCurrentUser()
  console.log(
    "🚀 ~ AuthGuard ~ ownerInfo:",
    ownerInfo,
    isUserActive(userInfo, ownerInfo, tenantInfo),
  )
  const [payForOwnerBill, payForOwnerBillResponse] =
    usePayForOwnerBillManuallyMutation()

  const [getBilling, billing] = useLazyGetBillingQuery()
  const [getBillings, billings] = useLazyCountBillingsQuery()
  console.log(
    "🚀 ~ AuthGuard ~ billings:",
    billings?.data?.data.find(() => true),
  )
  useEffect(() => {
    console.log("🚀 ~ AuthGuard ~ ownerInfo.ownerStatus:", ownerInfo)
    if (
      ownerInfo &&
      (ownerInfo?.ownerStatus === OwnerStatus.Expired ||
        ownerInfo?.ownerStatus === OwnerStatus.Pending)
    ) {
      getBillings({
        filter: [
          [{ field: "leaseId", operator: "isNull" }],
          [{ field: "ownerId", operator: "=", value: ownerInfo?.id as string }],
          [
            {
              field: "paymentStatus",
              operator: "=",
              value: PaymentStatus.Pending,
            },
          ],
        ],
      })
      // if (userInfo?.role?.key === "owner" && ownerInfo?.id) {
      //   getBilling(ownerInfo?.id)
      // }
    }
  }, [getBillings])
  const currentUserRole = JSON.parse(
    localStorage.getItem("currentRole") as string,
  )?.key
  const currentUserPermission = JSON.parse(
    localStorage.getItem("userRolePermissions") as string,
  )
  const currentRole = useSelector((state: RootState) => {
    return state?.authReducer?.role
  })
  const currentPermission = useSelector((state: RootState) => {
    return state?.authReducer?.permission
  })
  // const
  function authenticate() {
    if (localStorage.userInfo !== undefined) {
      return true
    } else {
      return false
    }
  }

  /** Paywall modal */
  if (ownerInfo && !isUserActive(userInfo, ownerInfo, tenantInfo)) {
    return (
      <Modal
        opened={true}
        onClose={() => {}}
        title="Account Suspended"
        withCloseButton={false}
        centered
      >
        {userInfo?.role?.key === "owner" && (
          <div className="flex flex-col items-center justify-center gap-4">
            <h1 className="text-2xl font-bold">Account Suspended</h1>
            <p className="text-gray-500">
              Your account has been suspended because you have an unpaid bill.
              Please pay your outstanding bill of{" "}
              {formatCurrency(ownerInfo?.pricePerMonth)} ETB and upload a
              payment proof below.{" "}
            </p>
            <FileInput
              className="w-full"
              label="Payment Proof"
              value={fileInput}
              onChange={(file) => setFileInput(file)}
            />
            <div className="flex gap-4">
              <Button
                loading={payForOwnerBillResponse?.isLoading}
                onClick={() => {
                  if (fileInput) {
                    const formData = new FormData()
                    formData.set(
                      "paymentId",
                      billings?.data?.data.find(() => true)?.id as string,
                    )
                    formData.set("file", fileInput as File)
                    payForOwnerBill({
                      paymentId: billings?.data?.data.find(() => true)
                        ?.id as string,
                      data: formData,
                    })
                  }
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Upload Payment Proof
              </Button>
              <button
                onClick={() => {
                  localStorage.removeItem("accessToken")
                  localStorage.removeItem("userInfo")
                  localStorage.removeItem("refreshToken")
                  localStorage.removeItem("currentUser")
                  localStorage.removeItem("currentRole")
                  localStorage.removeItem("userRolePermissions")
                  localStorage.removeItem("ownerInfo")
                  localStorage.removeItem("tenantInfo")
                  window.location.href = "/login"
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Go to Login
              </button>
            </div>
          </div>
        )}

        {userInfo?.role?.key === "tenant" && (
          <div className="flex flex-col items-center justify-center gap-4">
            <h1 className="text-2xl font-bold">Account Suspended</h1>
            <p className="text-gray-500">
              Your account has been suspended. Please contact your Building
              Manager.
            </p>
          </div>
        )}

        {/* {(window.location.href = "/login")} */}
      </Modal>
    )
  }

  if (authenticate()) {
    if (permission !== undefined) {
      if (
        currentUserRole === "super_admin" ||
        currentUserPermission?.some((perm: any) => permission.includes(perm))
      ) {
        return children
      } else {
        notification(
          "info",
          "You don't have all the necessary permissions to access the data.Please wait until we load your permissions or refresh and try again.",
        )
        navigate("/")
      }
    } else return children
  } else {
    window.location.href = "/login"
  }

  // if (authenticate()) {
  //   if (role !== undefined) {
  //     if (currentUserRole === "super_admin" || role.includes(`${currentRole?.key}`)) {
  //       return children
  //     } else {
  //       notification(
  //         "info",
  //         "You don't have all the necessary roles to access the data.Please wait until we load your permissions or refresh and try again.",
  //       )
  //       navigate("/")
  //     }
  //   } else return children
  // } else {
  //   const truth = authenticate()
  //   if (!truth) {
  //     return <Navigate to="/login" />
  //   }
  // }
}
export default AuthGuard
